import { generateReadOneActionCreator } from 'actions/crudActionCreators';
import ACTION_NAMES from 'actions/ACTION_NAMES';
import routes from 'actions/routes';

export default {
    readCampaigns: generateReadOneActionCreator(routes.API_CONTACT, ACTION_NAMES.CONTACT_CAMPAIGNS, 'campaigns')
}
